import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError, AxiosResponse} from 'axios'
import {TreatmentRequestExtended} from '@/features/treatment-requests/types'
import {
    httpUpdateTreatmentRequest,
    HttpUpdateTreatmentRequestOptions,
    HttpUpdateTreatmentRequestPayload
} from './treatment-requests.http'
import {FormErrorResponse} from '@/types'

export const useUpdateTreatmentRequest = ({
    urlParams,
    params,
    options
}: {
    urlParams: HttpUpdateTreatmentRequestOptions['urlParams']
    params: HttpUpdateTreatmentRequestOptions['params']
    options?: UseMutationOptions<
        AxiosResponse<TreatmentRequestExtended>,
        AxiosError<{errors: FormErrorResponse[]}>,
        HttpUpdateTreatmentRequestPayload
    >
}) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.UPDATE_TREATMENT_REQUEST],
        mutationFn: payload =>
            httpUpdateTreatmentRequest({
                urlParams,
                params,
                payload
            })
    })
